import React, { useState } from 'react';
import { Button, Pagination } from 'antd';
import qs from 'qs';

import { useQuery } from '@tanstack/react-query';
import dayjs from '@tt/dates/dayjs';

import { useManagementStore, useSettingStore, useUserState } from '../../store';
import axios from '../../utilities/axios';

import DayLogModalPage from './day-log-modal';
import DayNoteTradeCard from './day-note-trade-card';

import './styles.scss';

export default function DailyNotesPage() {
    const { getUser } = useUserState();
    const user = getUser();

    const { filter } = useSettingStore((state) => state);
    const { viewAs, publicView } = useManagementStore((state) => state);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectDayTrade, setSelectDayTrade] = useState(null);
    const isViewAsActive =
        JSON.stringify(viewAs?.newUser?.token || null) !==
        JSON.stringify(viewAs?.mainUser?.token || null);
    const modifiedFilter = { ...filter, dateRange: null, symbols: [], getAllofTickers: true };

    const pageSize = 5;

    const fetchDailyTrades = (inputFilter) =>
        axios
            .get('crud/daily-trade-notes', {
                params: {
                    accounts: inputFilter.accounts,
                    tags: inputFilter.tags,
                    showAllTags: inputFilter.showAllTags,
                    symbols: inputFilter.symbols,
                    status: inputFilter.status,
                    side: inputFilter.side,
                    assetType: inputFilter.assetType,
                    dateFrom: inputFilter.dateRange
                        ? dayjs(inputFilter.dateRange[0]).format('YYYY-MM-DD')
                        : '',
                    dateTo: inputFilter.dateRange
                        ? dayjs(inputFilter.dateRange[1]).format('YYYY-MM-DD')
                        : '',
                    getAllofTickers: inputFilter.getAllofTickers
                },
                paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
                headers: {
                    token: isViewAsActive ? viewAs.newUser.token : user?.token
                }
            })
            .then((response) => {
                let responseData = null;
                if (response.status === 200) {
                    responseData = response.data.filter((x) => x.dateFormat);
                }

                return responseData;
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    const { isLoading, data } = useQuery(['daily-trade-notes', filter], () =>
        fetchDailyTrades(publicView.isActive ? modifiedFilter : filter)
    );

    return (
        <div className="dailyNotes">
            <div className="dayNoteHeader">
                <h2>Daily Notes</h2>
                {!publicView.isActive && (
                    <Button
                        className="submit-btn"
                        type="primary"
                        size="middle"
                        onClick={() => {
                            setIsModalOpen(true);
                            setSelectDayTrade(null);
                        }}
                    >
                        <span>+</span> Day log
                    </Button>
                )}
            </div>
            {isLoading === false && (
                <>
                    <div className="trades">
                        {data
                            ?.slice((currentPage - 1) * pageSize, currentPage * pageSize)
                            .map((item, key) => (
                                <DayNoteTradeCard
                                    dailyTradeNote={item}
                                    index={key}
                                    key={key}
                                    isInList={true}
                                    setSelectDayTrade={setSelectDayTrade}
                                    setIsModalOpen={setIsModalOpen}
                                />
                            ))}

                        <Pagination
                            current={currentPage}
                            total={data?.length}
                            pageSize={pageSize}
                            showSizeChanger={false}
                            showQuickJumper={false}
                            onChange={(page) => setCurrentPage(page)}
                            hideOnSinglePage={true}
                        />
                    </div>

                    <DayLogModalPage
                        disabledDates={data?.map((x) => x.date)}
                        dailyTradeNote={selectDayTrade}
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                    />
                </>
            )}
        </div>
    );
}
